<template>
    <div class="">
        <div class="page-loader-wrapper" v-bind:class="{ 'hide': loaded === true }">
            <div class="loader">
                <div class="preloader">
                    <div class="spinner-layer pl-red">
                        <div class="circle-clipper left">
                            <div class="circle"></div>
                        </div>
                        <div class="circle-clipper right">
                            <div class="circle"></div>
                        </div>
                    </div>
                </div>
                <p>Please wait...</p>
            </div>
        </div>
        <div class="overlay"></div>

        <Header></Header>
        <Sidebar></Sidebar>

        <router-view class="animated fadeIn"></router-view>
    </div>
</template>

<script>
  // import FormLine from '../components/FormLine.vue'
  import Header from '../components/Header.vue'
  import Sidebar from '../components/Sidebar.vue'

  export default {
    name: 'Main',
    components: {
      Header,
      Sidebar
    },
    data: function () {
      return {
        loaded: false
      }
    },
    mounted: function () {
      setTimeout(() => {
        this.loaded = true
      }, 1000)
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Main.vue?7d04ced8